import axios from 'axios';
import { AdresseIP } from './AdresseIp';

export class AffectationService {

    constructor(){
        this.adresse = new AdresseIP()
    }
    affectationCite(newAnalyse) {
        const url = this.adresse.getAdresseIP() +"/service/api/hebergement-cenou/campus-faso/analyse-dossier"
        return axios.patch(url,newAnalyse)
                    .then(res => res);
    }

    getDossierEtudiant(ine, idDossier){
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/dossier/depot?ineEtudiant='+ine+'&idDossier='+idDossier
        return axios.get(url)
                    .then(res => res.data)
    }
    assignStudent(payload){
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/affectation-cite'
        return axios.post(url,payload)
                    .then(res => res.data);
    }

    getAdmissibles(idDirection, idAnnee){
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/dossierAdmissible?idDirection='+idDirection+'&idAnnee='+idAnnee
        return axios.get(url)
                    .then(res => res.data)
    }

    getAssignedList(idCite, idAnnee){
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/affectations-cite?idCite='+idCite+'&idAnnee='+idAnnee
        return axios.get(url)
                    .then(res => res.data)
    }
    getOccupantsByChambre(idChambre){
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/affectation-lit/chambre?idChambre='+idChambre
        return axios.get(url)
                    .then(res => res.data)
    }
    assignToBed(payload){
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/affectation-lit'
        return axios.post(url,payload)
                    .then(res => res.data);
    }
    getAssignedListByCite(idCite, idAnnee){
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/affectations-cite?idCite='+idCite+'&idAnnee='+idAnnee
        return axios.get(url)
                    .then(res => res.data)
    }

    getAssignmentStats(idCite, idSession){
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/affectation-cite-statistiques?idCite='+idCite+'&idSessionCenou='+idSession
        return axios.get(url)
                    .then(res => res.data)
    }
    
}